import classes from './CartItem.module.css';

const CartItem = (props) => {
  const price = `${parseFloat(props.price).toFixed(2)}`;

  return (
    <li className={classes['cart-item']}>
      <div>
        <p>{props.name}</p>
        <div className={classes.summary}>
          <span className={classes.price}>&#8373;{price}</span>
          <span className={classes.quantity}>x {props.quantity}</span>
        </div>
      </div>
      <div className={classes.actions}>
        <button onClick={props.onRemove}>−</button>
        <button onClick={props.onAdd}>+</button>
      </div>
    </li>
  );
};

export default CartItem;
